import { typo } from '@design-system/styles'
import { css } from '@emotion/react'

import colors from './colors'

const linkStyle = css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${typo.heading05};
  text-decoration: none;
  color: ${colors.gray.$900};
  white-space: nowrap;

  .new-badge {
    position: absolute;
    top: -6px;
    right: -16px;
  }
`
const activeLinkStyle = {
  fontWeight: 700,
  color: `${colors.primary}`,
  cursor: 'default',
}

export { activeLinkStyle, linkStyle }
